import { get } from 'lodash';

export const getCommonSettings = state => state.commonSettings;
export const getPostPageEnabled = state => get(state, 'commonSettings.postPageEnabled', false);
